import events from "@/bl-events/index.js"

let userInfoPromise

export function reset() {
  userInfoPromise = new Promise((resolve) => {
    events.on("setup:ready", (config) => {
      resolve(config)
    })
  })
}

reset()

export default function getUserInfo() {
  return userInfoPromise
}
